import React, { useState } from "react";
import { FaPhoneAlt, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { updateUserDetails } from "../../features/user/UserSlice";
import CustomInputBox from "../../components/Form/CustomInputBox";
import CustomButton from "../../components/Button/CustomButton";
import apiClient from "../../services/apiClient";

import CtiScreenImage from "../../assets/cti-screen-pop.png";
import LogoIcon from "../../assets/logo-icon.png";

const ProfilePage = () => {
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state?.userInfo?.user);

  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // console.log(data);
    try {
      const payload = new FormData();
      payload.append("name", formData?.name);
      payload.append("phone_number", formData?.phone_number);
      payload.append("user_id", userInfo?.id);

      // const payload = {
      //   user_id: userInfo?.id,
      //   ...formData,
      // };
      await apiClient.put("/user/update", payload);

      dispatch(
        updateUserDetails({
          name: formData?.name,
          phone_number: formData?.phone_number,
        })
      );
      navigate("/");

      toast.success("Updated !");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <section className="loginForm text-center">
      <div className="container-fluid min-vh-100 d-flex align-items-center p-0">
        <div className="row m-0 w-100 min-vh-100">
          <div className="col-md-5 d-flex min-vh-100 flex-column justify-content-center align-items-center bg-light p-4">
            <div className="mb-4">
              <img src={LogoIcon} alt="Logo" style={{ width: "100px" }} className="img-fluid" />
            </div>

            <div className="w-75">
              <h3 className="title">Profile Details</h3>
              <form onSubmit={handleProfileSubmit}>
                <CustomInputBox
                  placeholder=""
                  type="text"
                  required={true}
                  name="name"
                  icon={FaUser}
                  borderRadius="4px"
                  margin={"20px 0px"}
                  backgroundColor={"white"}
                  variant="outlined"
                  label="Name"
                  onChange={handleChange}
                  value={formData?.name}
                />
                <CustomInputBox
                  placeholder=""
                  type="number"
                  name="phone_number"
                  icon={FaPhoneAlt}
                  borderRadius="4px"
                  margin={"20px 0px"}
                  backgroundColor={"white"}
                  variant="outlined"
                  label="Phone no"
                  onChange={handleChange}
                  value={formData?.phone_number}
                />
                <CustomButton
                  type="submit"
                  className="my-2"
                  width={"100%"}
                  size="large"
                  loading={loading}
                >
                  Submit
                </CustomButton>
              </form>
            </div>
          </div>

          <div className="col-md-7 d-none d-md-flex align-items-center justify-content-center">
            <div className="fromImage">
              <img src={CtiScreenImage} alt="Right Section" className="img-fluid" />
              <h3 className="mb-2">Transform Every Call into a Success</h3>
              <p>
                Maximize Efficiency and Customer Satisfaction with
                <br className="d-non d-xl-block" />
                Our Intuitive Calling CRM Solution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfilePage;
